/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type NoteEntityTypeEnum = "contacts" | "containers" | "shipments" | "vessels" | "voyages" | "%future added value";
export type infoAddNoteInput = {
    clientMutationId?: string | null;
    entityType: NoteEntityTypeEnum;
    entitySlug: string;
    content: string;
    isSticky?: boolean | null;
};
export type NotesAddMutationVariables = {
    input: infoAddNoteInput;
};
export type NotesAddMutationResponse = {
    readonly infoAddNote: {
        readonly clientMutationId: string | null;
    } | null;
};
export type NotesAddMutation = {
    readonly response: NotesAddMutationResponse;
    readonly variables: NotesAddMutationVariables;
};



/*
mutation NotesAddMutation(
  $input: infoAddNoteInput!
) {
  infoAddNote(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddNotePayload",
    "kind": "LinkedField",
    "name": "infoAddNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotesAddMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotesAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a1efe93b5791c30f6bd71574583dde59",
    "id": null,
    "metadata": {},
    "name": "NotesAddMutation",
    "operationKind": "mutation",
    "text": "mutation NotesAddMutation(\n  $input: infoAddNoteInput!\n) {\n  infoAddNote(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ed68dd02f3c2e23c64855700c4190107';
export default node;
